import React, { useEffect, useState } from "react";
import { Button, Empty, Spin, Typography } from "antd";
import ProfileHeader from "../../Proflie/ProfileHeader";
import ExploreAgentCard from "../../Card/ExploreAgentCard";
import { TiArrowSortedDown } from "react-icons/ti";
import { fetchAllAssistants } from "../../../api/assistant";

const { Title } = Typography;

const OrganizationalAgents = ({
  chatWithAssistant,
  addFavoriteAssistant,
  userId,
  handleCardClick,
  favoriteAssistant,
  setRefresh,
  setFavoriteAssistant,
  HeaderContentChildren,
  enablePersonalize = false,
}) => {
  const [orgAgents, setOrgAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    console.log("Fetching organizational assistants for page:", page);

    const fetchAssistants = async () => {
      setLoading(true);
      try {
        const response = await fetchAllAssistants(page, 10);
        console.log("Full API Response:", response);

        if (response?.assistants) {
          setOrgAgents(prev => (page === 1 ? response.assistants : [...prev, ...response.assistants]));
          setTotal(response.meta.total);
          console.log("Updated Org Agents State:", response.assistants);
          console.log("Total Assistants:", response.meta.total);
        } else {
          console.warn("No assistants found in API response.");
        }
      } catch (error) {
        console.error("Error fetching organizational assistants:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAssistants();
  }, [page]);

  const handleLoadMore = () => {
    if (orgAgents.length < total) {
      setPage(prev => prev + 1);
      console.log("Load More clicked, new page:", page + 1);
    }
  };

  return (
    <Spin spinning={loading}>
      <ProfileHeader
        title="Organizational Agents"
        subHeading="Explore agents created under your organization."
      />
      {HeaderContentChildren}

      <div>
        {orgAgents.length === 0 && !loading ? (
          <>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            <p className="text-center">No organization agents found.</p>
            {console.log("Rendering Empty State: No assistants in orgAgents")}
          </>
        ) : (
          <div className="assistant-container">
            {orgAgents.map((assistant) => (
              <ExploreAgentCard
                key={assistant._id}
                agent={assistant}
                chatWithAssistant={chatWithAssistant}
                addFavoriteAssistant={addFavoriteAssistant}
                userId={userId}
                handleCardClick={handleCardClick}
                favoriteAssistantData={favoriteAssistant}
                setRefresh={setRefresh}
                setFavoriteAssistant={setFavoriteAssistant}
                enablePersonalize={enablePersonalize}
              />
            ))}
          </div>
        )}
      </div>

      {orgAgents.length > 0 && orgAgents.length < total && (
        <div className="load-more-container mt-1">
          <div className="load-more-button">
            <Button
              size="small"
              icon={<TiArrowSortedDown />}
              onClick={handleLoadMore}
            >
              Load More
            </Button>
          </div>
          <hr
            style={{
              borderColor: "hsl(0, 0%, 80%)",
              marginTop: "24px",
            }}
          />
        </div>
      )}

      {orgAgents.length >= total && orgAgents.length > 0 && (
        <span className="text-center w-100 d-block">There is no more data</span>
      )}
    </Spin>
  );
};

export default OrganizationalAgents;